import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="gender-select"
export default class extends Controller {
  static targets = [
    'genderSelect',
    'stateSelect',
  ]

  declare readonly genderSelectTarget: HTMLSelectElement
  declare readonly stateSelectTarget: HTMLSelectElement

  static values = {
    binaryGenderStates: Array
  }

  declare binaryGenderStatesValue: string[]

  connect () {
    this.updateOptions()
  }

  updateOptions () {
    const selectedState = this.stateSelectTarget.value
    if (this.binaryGenderStatesValue.includes(selectedState)) {
      this.hideNonBinaryOption()
    } else {
      this.showNonBinaryOption()
    }
  }

  hideNonBinaryOption () {
    const nonBinaryOption = this.genderSelectTarget.querySelector('option[value="non_binary"]')
    if (nonBinaryOption) {
      (nonBinaryOption as HTMLElement).style.display = 'none'
      if (this.genderSelectTarget.value === 'non_binary') {
        this.genderSelectTarget.value = ''
      }
    }
  }

  showNonBinaryOption () {
    const nonBinaryOption = this.genderSelectTarget.querySelector('option[value="non_binary"]')
    if (nonBinaryOption) {
      (nonBinaryOption as HTMLElement).style.display = 'block'
    }
  }
}
